import "./AffiliateCenter.css";
import { Table, Dropdown } from "react-bootstrap";
import useKeyScroll from "../../Hooks/useKeyScroll";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useState } from "react";
import CustomPagination from "../CustomPagination/CustomPagination";

function AffiliateCoupon() {
  const scrollContainerRef1 = useKeyScroll();
  const scrollContainerRef2 = useKeyScroll();
  const [codesCurrentPage, setCodesCurrentPage] = useState(1);
  const [codesRowsPerPage, setCodesRowsPerPage] = useState(10);

  const [memberCurrentPage, setMemberCurrentPage] = useState(1);
  const [memberRowsPerPage, setMemberRowsPerPage] = useState(10);

  const codesTotal = 25;
  const memberTotal = 45;
  return (
    <>
      <div className="affiliate_coupon_layout">
        <div className="affiliate_coupon_table coupon_content_card">
          <div className="premium_table_header">
            <h5>Affiliate Codes</h5>
            <div className="search_filter_wrapper">
              <div className="premium_search_box">
                <img
                  src="/build/search.svg"
                  alt="Search"
                  width={20}
                  height={20}
                />
                <input placeholder="Search coupons..." />
              </div>
              <button className="premium_filter_btn">
                <span>Filter</span>
                <img
                  src="/build/img/Icons/down_vector.svg"
                  alt="Filter"
                  width={14}
                  height={14}
                />
              </button>
            </div>
          </div>

          <div 
            className="affiliate_coupon_table_list"
            ref={scrollContainerRef1}
            tabIndex="0"
            style={{ outline: "none" }}
          >
            <Table hover responsive className="premium_table">
              <thead>
                <tr>
                  <th>SR NO</th>
                  <th>COUPON CODE NAME</th>
                  <th>NO. OF TIME USED</th>
                  <th>COMMISION EARNED</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td><span className="coupon_name_badge">BLACKFRIDAYSALE</span></td>
                  <td>5</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td><span className="coupon_name_badge">CYBERMONDAYSALE</span></td>
                  <td>5</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td><span className="coupon_name_badge">BOXINGDAYSALE</span></td>
                  <td>5</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td><span className="coupon_name_badge">MATCHDAYSALE</span></td>
                  <td>5</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td><span className="coupon_name_badge">THANKSGIVINGSALE</span></td>
                  <td>5</td>
                  <td>5</td>
                </tr>
              </tbody>
            </Table>

            <div className="premium_table_footer_wrapper">
              <CustomPagination
                totalItems={codesTotal}
                rowsPerPage={codesRowsPerPage}
                currentPage={codesCurrentPage}
                onPageChange={setCodesCurrentPage}
                onRowsPerPageChange={setCodesRowsPerPage}
              />
            </div>
          </div>
        </div>

        <div className="affiliate_create_coupon_card">
          <h4>Create a Coupon</h4>
          <div className="affiliate_coupon_details">
            <div className="premium_form_group">
              <label>Promo Code</label>
              <input type="text" className="premium_ac_input" placeholder="e.g. SUMMER50" />
            </div>

            <div className="premium_form_group">
              <label>Expiry Date</label>
              <input type="date" className="premium_ac_input" />
            </div>

            <div className="premium_form_group">
              <label>Number of Instances</label>
              <input type="number" className="premium_ac_input" placeholder="20" />
              <div className="unlimited_checkbox_wrapper">
                <input type="checkbox" id="unlimited" />
                <label htmlFor="unlimited" className="mb-0" style={{ fontSize: '13px', color: '#64748b' }}>Unlimited usage</label>
              </div>
            </div>

            <div className="premium_form_group">
              <label>Multi-redeem (Same Customer)?</label>
              <div className="d-flex align-items-center gap-4 py-1">
                <div className="d-flex align-items-center gap-2">
                  <input type="radio" name="multiRedeem" id="yes" />
                  <label htmlFor="yes" className="mb-0">Yes</label>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <input type="radio" name="multiRedeem" id="no" />
                  <label htmlFor="no" className="mb-0">No</label>
                </div>
              </div>
            </div>

            <div className="form_footer_info">
              <p>* The coupon code will allow the affiliate to earn 5% on the
                purchase.</p>
              <p>* The Client will also get 5% discount irrespective of the amount
                of package they opt for.</p>
            </div>

            <div className="form_actions">
              <button className="ac_cancel_btn">Cancel</button>
              <button className="ac_next_btn" style={{ flex: 2 }}>Create Coupon</button>
            </div>
          </div>
        </div>
      </div>

      <div className="affiliate_coupon_member">
        <div className="coupon_content_card">
          <div className="premium_table_header">
            <h4>Affiliate Member History</h4>
            <button className="premium_filter_btn">
              <span>Filter</span>
              <img
                src="/build/img/Icons/down_vector.svg"
                alt="Filter"
                width={14}
                height={14}
              />
            </button>
          </div>

          <div 
            className="affiliate_coupoun_member_table"
            ref={scrollContainerRef2}
            tabIndex="0"
            style={{ outline: "none" }}
          >
            <Table hover responsive className="premium_table">
              <thead>
                <tr>
                  <th>SR NO</th>
                  <th>TX NO.</th>
                  <th>STATUS</th>
                  <th>AMOUNT (USD)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>pz_razorpay_101</td>
                  <td><span className="status_processing">Processing</span></td>
                  <td>$10.00</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>pz_razorpay_102</td>
                  <td><span className="status_processing">Processing</span></td>
                  <td>$5.00</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>pz_razorpay_103</td>
                  <td><span className="status_confirmed">Confirmed</span></td>
                  <td>$15.00</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>pz_razorpay_104</td>
                  <td><span className="status_cancelled">Cancelled</span></td>
                  <td>$10.00</td>
                </tr>
              </tbody>
            </Table>

            <div className="premium_table_footer_wrapper">
              <CustomPagination
                totalItems={memberTotal}
                rowsPerPage={memberRowsPerPage}
                currentPage={memberCurrentPage}
                onPageChange={setMemberCurrentPage}
                onRowsPerPageChange={setMemberRowsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AffiliateCoupon;
